import React from 'react';
import './not-found.scss';
import routeService from '../../../routes/route.service';

export default function NotFound() {
  return (
    <div className="not-found-container">
      <div className="not-found">
        <div className="not-found-404">
          <h1>Oops!</h1>
          <h2>404 - The Page can't be found</h2>
        </div>
        <a href={routeService.getLoginPath()}>Go to Login</a>
      </div>
    </div>
  );
}
